import { Skeleton, Tooltip } from '@heroui/react';

export type DeploymentSizeCellProps = {
  /** Size name, such as Small, shown in the badge's tooltip. */
  size: string;
  /** One-letter size, such as S. Empty when the size is not a known one. */
  abbreviation: string;
};

export function DeploymentSizeCell({
  size,
  abbreviation
}: Readonly<DeploymentSizeCellProps>) {
  return (
    <div className='w-[80px]'>
      {abbreviation ? (
        <Tooltip content={size} placement='bottom'>
          <span
            data-testid='deployment-size-badge'
            className='inline-flex h-5 min-w-5 items-center justify-center rounded bg-secondary-container px-1 text-xs font-semibold text-on-secondary-container'
          >
            <span aria-hidden='true'>{abbreviation}</span>
            <span className='sr-only'>{size}</span>
          </span>
        </Tooltip>
      ) : (
        <p>—</p>
      )}
    </div>
  );
}

export function DeploymentSizeCellSkeleton() {
  return (
    <div className='w-[80px]'>
      <Skeleton className='h-5 w-5 rounded' />
    </div>
  );
}
